import { render, staticRenderFns } from "./CircuitBreakerTab.vue?vue&type=template&id=a4a684e4&scoped=true&"
import script from "./CircuitBreakerTab.vue?vue&type=script&lang=js&"
export * from "./CircuitBreakerTab.vue?vue&type=script&lang=js&"
import style0 from "./CircuitBreakerTab.vue?vue&type=style&index=0&id=a4a684e4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a684e4",
  null
  
)

export default component.exports